module.exports = __webpack_public_path__ + "img/big-hearted-halloween.47349ce6.png";